import { Role, User } from "myfitworld-model"
import { getCurrentUserRole } from "src/api/usersApi";
import { UserProviderState } from "./UserProvider";

export interface UserProviderRolesInterface{
    isOrgAdmin:boolean,
    isTrainerWithinOrg: boolean
}
export const defaultUserProviderRoles: UserProviderRolesInterface ={
    isOrgAdmin: false,
    isTrainerWithinOrg: false,
}
export const defaultUserProviderState :UserProviderState={
  user: null,
  loading: true,
  needsInvitation: false,
  enterApplication: false,
  userRole: defaultUserProviderRoles,
  resetUser: function (): void {
    throw new Error("Function not implemented.");
  }
}
export const withDefaultsUserProviderState = (overrides: Partial<UserProviderState>): UserProviderState => ({
    ...defaultUserProviderState,
    ...overrides,
  });

export const getUserRole =  (user : User) : UserProviderRolesInterface => {    
    const currentUserRole = getCurrentUserRole(user)
    
    if(!currentUserRole){
        return defaultUserProviderRoles;
    }

    const isUserTrainerWithinAnOrganization = [Role.Admin,Role.AssistantTrainer,Role.Trainer,].includes(currentUserRole)
    const isUserOrgAdmin = currentUserRole !== Role.Admin

    return {
      isOrgAdmin : isUserOrgAdmin,
      isTrainerWithinOrg : isUserTrainerWithinAnOrganization
    }
}

export const formatDatePropFromUser = (dateProp: string | undefined) : Date=>{
  if(dateProp){
    return new Date(Date.parse(dateProp));
  } else return new Date();
}